/**
 * Only an in-app relative path may be used as a post-auth redirect target — a
 * raw `?callbackUrl=` query param is attacker-controlled and `signIn(...,
 * {redirect: false})` skips next-auth's own callback-URL validation, so this
 * check has to happen here before the value ever reaches `router.push`.
 */
export function safeRedirectPath(path: string | null | undefined, fallback: string): string {
  if (!path) return fallback;
  // Next's router resolves the href via `new URL(href, location.href)` before
  // deciding whether to navigate off-site — and the WHATWG URL parser strips
  // ASCII tab/newline/CR (anywhere in the string) and trims leading C0/space
  // BEFORE parsing. So "/\t/evil.com" isn't caught by a raw startsWith("//")
  // check yet still resolves to a different origin and triggers a real
  // browser navigation there. Normalize the same way first, then validate.
  const normalized = path.replace(/[\t\n\r]/g, "").replace(/^[\x00-\x20]+|[\x00-\x20]+$/g, "");
  if (!normalized.startsWith("/") || normalized.startsWith("//") || normalized.startsWith("/\\")) return fallback;
  return normalized;
}
